<template>
    <div
        v-if="event === 'TS'"
        class="d-flex align-items-center my-2 athlete-container"
        :class="{ dark: $vuetify.theme.dark }"
        @click="visitResultPage"
    >
        <div class="d-flex align-center">
            <v-chip class="mr-2" :class="chipClass" small :ripple="false">{{ startList.order }}</v-chip>
        </div>
        <div class="d-flex align-center">
            <scorsync-avatar :person="startList.athlete" class="mr-1" />
            <scorsync-avatar :person="startList.athlete2" class="mr-1" />
        </div>
        <div class="d-flex flex-column justify-content-center ml-2">
            <div class="d-flex align-center">
                <div>
                    <div style="line-height: 0.9rem">
                        <div>
                            <span>{{ startList.athlete.name }}</span>
                            <span v-if="startList.equipment" class="ml-1">
                                <span>(</span>
                                <strong>{{ startList.equipment }}</strong>
                                <span>)</span>
                            </span>
                        </div>
                        <div>
                            {{ startList.athlete2.name }}
                        </div>
                    </div>
                    <div style="line-height: 0.9rem">
                        <span class="athlete-category-description">
                            {{ startList.description({ without: ['event'] }) }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div
        v-else
        class="d-flex align-items-center my-2 athlete-container"
        :class="{ dark: $vuetify.theme.dark }"
        @click="visitResultPage"
    >
        <div class="d-flex align-center">
            <v-chip class="mr-2" style="" :class="chipClass" small :ripple="false">{{ startList.order }}</v-chip>
        </div>
        <div class="d-flex align-center">
            <scorsync-avatar :person="startList.athlete" class="mr-2" />
        </div>
        <div class="d-flex align-center">
            <div>
                <div style="line-height: 0.9rem">
                    <span>{{ startList.athlete.name }}</span>
                    <span v-if="startList.equipment" class="ml-1">
                        <span>(</span>
                        <strong>{{ startList.equipment }}</strong>
                        <span>)</span>
                    </span>
                </div>
                <div style="line-height: 0.9rem">
                    <span class="athlete-category-description">
                        {{ startList.description({ without: ['event'] }) }}
                    </span>
                </div>
            </div>
        </div>
        <div v-if="state.showQualified" class="d-flex align-center">
            <qualification-check :qualifier="qualificationState" :event="event" class="ml-2" />
        </div>
        <div v-if="$store.state.debugMode" class="d-flex align-center ml-auto">
            {{ startList.id }}
        </div>
    </div>
</template>

<script>
import find from 'lodash/find.js';
import ScorsyncAvatar from '@/Components/ScorsyncAvatar.vue';
import QualificationCheck from '@/Components/QualificationCheck.vue';
import StartList from '@/Models/StartList.js';

export default {
    name: 'ClubScheduleAthlete',

    components: { QualificationCheck, ScorsyncAvatar },

    inject: ['state'],

    props: {
        startList: {
            type: StartList,
            required: true,
        },

        event: {
            type: String,
            required: true,
        },

        chipClass: {
            type: String,
            default: '',
        },
    },

    computed: {
        qualificationState() {
            if (this.event === 'TS') {
                return {};
            }

            const qualificationInfo = find(this.state.qualifications, { athlete_id: this.startList.athlete.id });

            if (!qualificationInfo) {
                return {};
            }

            return qualificationInfo;
        },
    },

    methods: {
        visitResultPage() {
            this.$inertia.visit(`/result-categories/${this.startList.result_category_id}`);
        },
    },
};
</script>

<style lang="scss" scoped>
.athlete-container {
    background: #f1f1f1;
    padding: 0.25rem;
    border-radius: 10px;
    cursor: pointer;
}

.dark {
    background: #343434;
}

.athlete-category-description {
    font-size: 0.75rem;
    color: #999;
}
</style>
